import type { ChatSession } from "@/types";

export type ChatRevealUpdate = {
  status: "pending_peer" | "revealed";
  actorId?: string;
  currentUserId?: string | null;
};

export type ChatRevealPatchResult = {
  chats: ChatSession[];
  patched: boolean;
};

export function applyChatReveal(
  chats: ChatSession[],
  chatId: string,
  update: ChatRevealUpdate,
): ChatRevealPatchResult {
  let patched = false;
  const nextChats = chats.map((chat) => {
    if (chat.id !== chatId) return chat;
    patched = true;

    if (update.status === "revealed") {
      return {
        ...chat,
        revealed: true,
        revealStatus: "revealed" as const,
        revealRequestedByMe: true,
        revealRequestedByPeer: true,
      };
    }

    const actorIsMe =
      update.actorId != null &&
      update.currentUserId != null &&
      update.actorId === update.currentUserId;
    return {
      ...chat,
      revealStatus: actorIsMe ? ("requested" as const) : ("pending_peer" as const),
      revealRequestedByMe: actorIsMe || Boolean(chat.revealRequestedByMe),
      revealRequestedByPeer: !actorIsMe || Boolean(chat.revealRequestedByPeer),
    };
  });

  return { chats: nextChats, patched };
}
